import React, { useEffect, useState, useMemo } from "react";
import "../style/page/symptoms.scss";
import BasicTable from "../maincomponent/reacttable/table";
import axios from "axios";
import { symptomslist, symptomsdelete, symptomsexcel } from "../../text/apidata";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { symptoms, symptomsid, sidebar } from "../redux/reducer/counterslice";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import SymptomsForm from "../form/symptomsform";
import Swal from "sweetalert2";

function Symptoms(props) {
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [age, setAge] = React.useState();
  const [datacount, setdatacount] = useState();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const symid = useDispatch();
  const Symptomsnav = useNavigate();
  const routehead = useNavigate();
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const symptomsedit = useSelector((state) => state.counter.symptoms);
  const [isactivefilterdata, setisactivefilterdata] = useState("");
  const [popup, setpopup] = useState(false);
  const [id, setid] = useState();
  const [sno, setsno] = useState(0);
  let roledata = localStorage.getItem("role");


  // console.log(dtpageindex,"0889")
  const dropdownhandlechange = (e) => {
    // console.log(e);
    // setAge(e.target.value)
    if (e) {
      // Symptomsnav("/SymptomsForm");
      dispatch(symptoms("symptomsedit"));
      symid(symptomsid(e));
    }
  };
  const deletespeciality = (e) => {
    setid(e);
    setpopup(true);
  };
  useEffect(() => {
    if (searchQuery != "") {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(
        searchQuery
      );
      if (hasNumbers || hasLetters || hasSpecialChars) {
        props.loaderchange("true");
        axios({
          method: "get",
          url: symptomslist,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: searchQuery ? "1" : dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
            is_active: isactivefilterdata,
          },
        })
          .then((res) => {
            // console.log(res.data,res.data.data_count, "table");

            settableheaderdata(res.data.data);
            setdatacount(res.data.data_count);
            props.loaderchange("false");
          })
          .catch((error) => {
            console.log(error);
            props.loaderchange("false");
            // setdtPageindex(dtpageindex-1)
            // console.log(dtpageindex)
            props.popupalert("true");
            props.popuptext("No Data Available");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          });
      }
    } else {
      props.loaderchange("true");
      axios({
        method: "get",
        url: symptomslist,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: searchQuery ? "1" : dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
          is_active: isactivefilterdata,
        },
      })
        .then((res) => {
          // console.log(res.data,res.data.data_count, "table");

          settableheaderdata(res.data.data);
          setdatacount(res.data.data_count);
          props.loaderchange("false");
        })
        .catch((error) => {
          console.log(error);
          props.loaderchange("false");
          // setdtPageindex(dtpageindex-1)
          // console.log(dtpageindex)
          props.popupalert("true");
          props.popuptext("No Data Available");
          setTimeout(() => {
            props.popupalert("false");
          }, 2000);
        });
    }
  }, [dtpageindex, dtpagesize, searchQuery, symptomsedit, isactivefilterdata]);
  const columns = useMemo(
    () => [
      {
        Header: "S.NO",
        accessor: "",
        Cell: (row) => {
          console.log(row.row);
          console.log(sno);
          return <p>{row.row.original.slno}</p>;
        },
      },

      {
        Header: "Symptoms",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.speciality)
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="symptoms"
                  data-tooltip-content={String(row.row.original.symptoms)}
                >
                  {String(row.row.original.symptoms)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Speciality",
        accessor: "",
        Cell: (row) => {
          const items = [];
          row.row.original.speciality.forEach((item) => items.push(item.name));
          const shorten =
            items.toString().length > 20
              ? `${items.toString().substring(0, 15)}...`
              : `${items.toString()}`;

          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="symptoms"
                  data-tooltip-content={`${items.toString()}`}
                >
                  {shorten}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Active",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.is_active == false ? "No" : "Yes"
                }
              >
                {row.row.original.is_active == false ? (
                  <p style={{ color: "red", fontWeight: 700 }}>No</p>
                ) : (
                  <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                )}
              </p>
            </>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original)
          //settablevalue(row.row.original)

          return (
            <>
              {/* <FormControl variant="standard" sx={{ minWidth: 60 }}>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  disableUnderline
                  value={age}
                  onChange={(e) => dropdownhandlechange(row.row.original.id)}
                  label="Age"
                  defaultValue="none"
                  style={{
                    fontSize: "12px",
                  }}
                >
                  <MenuItem value="none" disabled style={{ display: "none" }}>
                    Select
                  </MenuItem>
                  <MenuItem value={1}>Edit</MenuItem>
                </Select>
              </FormControl> */}
              <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm edit"
                  onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                >
                  <i class="bi bi-pencil-fill"></i> Edit
                </button>
                <button
                  type="button"
                  class="btn btn-danger btn-sm delete"
                  onClick={(e) => deletespeciality(row.row.original.id, e)}
                >
                  <i class="bi bi-trash3"></i> Delete
                </button>
              </div>
            </>
          );
        },
      },
    ],
    [sno]
  );

  const creatfunction = (e) => {
    dispatch(symptoms("create"));
  };

  const routeback = (e) => {
    routehead("/Settings");
  };
  const pagesize = (arg) => {
    // alert(arg);
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const loaderchangechild = (arg) => {
    // console.log(arg,"jkh")
    props.loaderchange(arg);
  };
  const popupalertchild = (arg) => {
    props.popupalert(arg);
  };
  const popuptextchild = (arg) => {
    props.popuptext(arg);
  };
  const confirm = () => {
    props.loaderchange("true");
    axios({
      method: "delete",
      url: symptomsdelete + id + "/",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
    })
      .then((res) => {
        console.log(res.data);
        // window.location.href = "/Banner";
        setpopup(false);
        window.location.reload();

        props.loaderchange("false");

        props.popupalert("true");
        props.popuptext("Data Deleted Successfully");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      })
      .catch((error) => {
        console.log(error);
        props.loaderchange("false");
        // setdtPageindex(dtpageindex-1)
        // console.log(dtpageindex)
      });
  };

  const datadownload = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "Do You Want To Download The Data?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: 'get',
          url: symptomsexcel,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        }).then((res) => {
          window.open(res.data.data, '_self')
          // Swal.fire(
          //   'Deleted!',
          //   'Your file has been deleted.',
          //   'success'
          // )

          console.log(res)

        }).catch((err) => {

        })
      }
    })
  }
  return (
    <>
      <div
        className={sideactive ? "maincontainer_sym-sa" : "maincontainer_sym"}
      >
        <div className="patient-header">
          <div className="row">
            <div className="col">
              <h3 className="page-title">Symptoms</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a
                    href="/"
                    style={{ textDecoration: "none", color: "black" }}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </a>
                </li>
                <li className="breadcrumb-item active">Symptoms</li>
              </ul>
            </div>
            <div class="col-sm-5 col">
              <a
                onClick={(e) => creatfunction(e)}
                style={{
                  backgroundColor: "#1b5a90",
                  border: "1px solid #1b5a90",
                  color: "white",
                }}
                data-toggle="modal"
                class="btn btn-primary float-right mt-2"
              >
                Add
              </a>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginTop: 20 }}>
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="Symptoms">
                  <div className="table-content-Symptoms">
                    <form onSubmit={handleSubmit}
                      style={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <div
                        class="input-group rounded"
                        style={{ width: "250px", height: "40px" }}
                      >
                        <input
                          type="search"
                          class="form-control rounded"
                          aria-label="Search"
                          aria-describedby="search-addon"
                          value={searchQuery}
                          onKeyDown={(e) => {
                            if (e.target.value.length === 0 && e.which === 32) {
                              e.preventDefault();
                            }
                          }}
                          onInput={(e) => {
                            if (e.target.value.length <= "100") {
                              setSearchQuery(e.target.value);
                            } else {
                              e.preventDefault();
                            }
                          }}
                          // onKeyDown={(e)=>{if(e.which=="32"){
                          //   e.preventDefault()
                          // }}}

                          min="0"
                          max="10"
                          label="Search"
                          placeholder="Search..."
                          required
                        />
                        <span
                          class="input-group-text border-0 bg-transparent"
                          id="search-addon"
                        >
                          <i
                            class="bi bi-search"
                            style={{
                              color: "#1b5a90",
                              width: "20px",
                              height: "20px",
                            }}
                          ></i>
                        </span>
                      </div>
                      <>

                        <div align="center" type="button" >
                          <a class="dnbtn" onClick={(e) => {
                            datadownload();
                          }}></a>
                        </div>
                      </>
                    </form>

                    <div className="table-Symptoms">
                      <BasicTable
                        columns={columns}
                        data={tableheaderdata}
                        pagesize={pagesize}
                        pageindex={pageindex}
                        dtpagesize={dtpagesize}
                        dtpageindex={dtpageindex}
                        datacount={datacount}
                        isactive={true}
                        isactivefilterdata={isactivefilterdata}
                        setisactivefilterdata={setisactivefilterdata}
                        setsno={setsno}
                        sno={sno}
                        id={"sym"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ReactTooltip
          id="symptoms"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            marginRight: "10px",
            fontWeight: 400,
            width: "auto",
          }}
        />
      </div>
      {symptomsedit == "symptomsedit" || symptomsedit == "create" ? (
        <>
          <SymptomsForm
            loaderchange={loaderchangechild}
            popupalert={popupalertchild}
            popuptext={popuptextchild}
          />
        </>
      ) : (
        ""
      )}
      {popup && (
        <>
          <div className="logout_popup">
            <div class="container1">
              <div class="cookiesContent" id="cookiesPopup">
                <button
                  class="close"
                  onClick={(e) => {
                    setpopup(false);
                  }}
                >
                  ✖
                </button>
                {/* <img src={logoutimg} alt="cookies-img" /> */}
                <p style={{ marginTop: "20px" }}>
                  Do You Want to Delete the Data?
                </p>
                <div style={{ display: "flex" }}>
                  <button class="accept p-2 m-2" onClick={(e) => confirm()}>
                    Yes!
                  </button>
                  <button
                    class="accept p-2 m-2"
                    onClick={(e) => setpopup(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Symptoms;
